import { ButtonStyle, ControlSize, ControlType, Property, PropertyType } from "../../../base/types";

import { DefaultLabel } from "../../widgets";
import { DesignerMode } from "../../types";
import { FC, useEffect, useState } from "react";
import { IControlAttributes } from "../../../base/models";
import { MUIIcon } from "../../../widgets";
import { Registry } from "../../../base/register";
import clsx from "clsx";
import { getButtonClass } from "../buttons/helper";
import { useGetProperties } from "../../../base/hooks";
import { Link } from "react-router-dom";

export const DownloadableDocument: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    const label: string | undefined = properties[Property.Label];
    const tooltip: string | undefined = properties[Property.Tooltip];
    const url: string | undefined = properties[Property.Url];
    const target: string | undefined = properties[Property.Target];
    const icon: string | undefined = properties[Property.MaterialIcon]
    const style: ButtonStyle | undefined = properties[Property.BackgroundStyle]
    const size: ControlSize | undefined = properties[Property.Size]

    if (designerMode === DesignerMode.Draft) {
        return (
            <div className={clsx(getButtonClass(style, size, "btn btn-link btn-sm"), className)} title={tooltip}>
                {(icon) && <MUIIcon iconName={icon} className={clsx({ "me-1": !!label })} />}
                <DefaultLabel
                    control={control}
                    propertyId={Property.Label}
                    defaultLabel="Downloadable Document"
                    className="text-hover-primary bg-secondary" />
                {children}
            </div>)
    }

    return (
        <DownloadLinkCell fieldUrl={url || ''} children={children} label={label} icon={icon} target={target} />
    )
}

const DownloadLinkCell = ({ fieldUrl, children, label, icon,target }: {
    fieldUrl: string,
    label?: string,
    icon?: string,
    target?: string,
    children?: React.ReactNode,
}) => {
    const [documentUrl, setDocumentUrl] = useState<string>()

    useEffect(() => {
        if (!fieldUrl) {
            return;
        }

        let url = fieldUrl
        if (url === undefined)
            return;

        if (url.startsWith("https://")) {
            url = new URL(url).pathname;
        }

        setDocumentUrl(url);
        // eslint-disable-next-line
    }, [fieldUrl])

    if (!documentUrl) {
        return <>{children}</>
    }

    return <>
        <Link
            target={target}
            to={`/api/documents/document?url=${encodeURIComponent(documentUrl)}`}>
            <span>{label}</span>
            {children}
        </Link>
    </>
}

Registry.addControl({
    id: "5742f5ca-9201-463b-8ea8-cc2fafe8f1e9",
    name: "Downloadable Document",
    type: ControlType.DownloadableDocument,
    properties: [
        { id: Property.MaterialIcon, name: 'Icon', type: PropertyType.MaterialIcon },
        { id: Property.Label, name: 'Label', type: PropertyType.String },
        { id: Property.Url, name: 'Url', type: PropertyType.String },
        { id: Property.Target, name: 'Target', type: PropertyType.String },
        { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String },
        { id: Property.BackgroundStyle, name: 'Style', type: PropertyType.ButtonStyle },
        { id: Property.Size, name: 'Size', type: PropertyType.ControlSize },
    ],
    component: DownloadableDocument
})
